// components/misc/DataTranslateNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const DataTranslateNode = ({ data, id, isConnectable }) => {
  const handleStyle = {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    transition: "all 0.2s ease-in-out",
    transformOrigin: "center",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  };

  const sourceHandleStyle = {
    ...handleStyle,
    right: "-4px",
    backgroundColor: "black",
  };

  const targetHandleStyle = {
    ...handleStyle,
    left: "-4px",
    backgroundColor: "black",
  };

  const handleHoverStyle = {
    transform: "translateY(-50%) scale(3.5)",
  };

  const handleClick = () => {
    if (data.onClick) {
      data.onClick(id);
    }
  };
  return (
    <div
      onClick={handleClick}
      className="relative rounded-md border border-gray-500 bg-white px-2 py-1"
    >
      <Handle
        type="source"
        position={Position.Right}
        id="dt-a"
        isConnectable={isConnectable}
        style={sourceHandleStyle}
        onMouseOver={(e) => {
          e.target.style.transform = handleHoverStyle.transform;
        }}
        onMouseOut={(e) => {
          e.target.style.transform = handleStyle.transform;
        }}
      />
      <Handle
        type="target"
        position={Position.Left}
        id="dt-b"
        isConnectable={isConnectable}
        style={targetHandleStyle}
        onMouseOver={(e) => {
          e.target.style.transform = handleHoverStyle.transform;
        }}
        onMouseOut={(e) => {
          e.target.style.transform = handleStyle.transform;
        }}
      />
      <div className="flex items-center justify-center">
      <svg className="h-6 w-6" fill="#148be6" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" stroke="#148be6"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"></path></g></svg>
      </div>
    </div>
  );
};

export default DataTranslateNode;
